export default "__VITE_ASSET__Cn4KHuCg__"